import axios from "axios";

const BASE_URL = "https://tez.ulushasturk.com/api.php";

const AUTH_URL = "https://tez.ulushasturk.com/auth.php";

export const getMachines = () => axios.get(`${BASE_URL}?action=machines`);

export const getDashboardStats = () =>
  axios.get(`${BASE_URL}?action=dashboard_stats`);

export const getMachineHistory = (id) =>
  axios.get(`${BASE_URL}?action=machine_history&id=${id}`);

export const getLatestLog = (id) =>
  axios.get(`${BASE_URL}?action=latest_log&id=${id}`);

export const getWorkOrders = (machineId) =>
  axios.get(
    `${BASE_URL}?action=work_orders${machineId ? "&id=" + machineId : ""}`,
  );

export const createWorkOrder = (data) =>
  axios.post(`${BASE_URL}?action=create_work_order`, data);

export const updateWorkOrder = (data) =>
  axios.post(`${BASE_URL}?action=update_work_order`, data);

export const getMaintenancePlans = (machineId) =>
  axios.get(
    `${BASE_URL}?action=maintenance_plans${machineId ? "&id=" + machineId : ""}`,
  );

export const completeMaintenancePlan = (data) =>
  axios.post(`${BASE_URL}?action=complete_maintenance`, data);

export const getOverduePlans = () =>
  axios.get(`${BASE_URL}?action=overdue_plans`);

export const login = (username, password) =>
  axios.post(AUTH_URL, { action: "login", username, password });

export const logout = () => axios.post(AUTH_URL, { action: "logout" });

export const getMe = () => axios.post(AUTH_URL, { action: "me" });
